import {
  List,
  ListItem,
  ListItemIcon,
  Divider,
  Menu,
  MenuItem,
  Slider,
  Popover,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import typeofvisit from "../../assets/tasks/ic_outline-contact-support.svg";
import diagnosisicon from "../../assets/tasks/material-symbols-light_diagnosis-outline.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import DiagnosisPopup from "../../orders/popups/diagnosispopup";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import {
  updatelov2Value,
  updatelovValue,
  updateTov2Value,
  updateTovValue,
} from "../../reduxtoolkit/dump";
import CloseIcon from '@mui/icons-material/Close';
import {
  convertDateTimeToCustomFormat,
  formattedDob,
} from "../../utils/dateutils/dateutility";
import ToastMessage from "../../utils/mui/righttoptoast";
import AddIcon from "@mui/icons-material/Add";
import Level from "../../../src/assets/orders/Level.svg";
import Fallowup from "../../../src/assets/orders/Fallowup.svg";
import CustomDropdown from "./CustomDropdown";
import dayjs from "dayjs";

const OrdersSideNav = ({ isCollapsed, setIsCollapsed, tab, setTab, data }) => {
  const percentage = 100;
  const { id, dt } = useParams();
  const miniSidenav = isCollapsed;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const circleStyle = {
    ...(data?.deductiblemet && { backgroundColor: `#${data.deductiblemet}` }),
  };
  const[isLoading,setLoading]=useState(false)
  const [diagnosispopup, setisDiagnosisPopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [extraAnchorEl, setExtraAnchorEl] = useState(null);
  const extraOpen = Boolean(extraAnchorEl);
  const handleOpenExtra = (e) => setExtraAnchorEl(e.currentTarget);
  const handleCloseExtra = () => setExtraAnchorEl(null);
  const [showExtraTovLov, setShowExtraTovLov] = useState(false); // State to toggle extra tov/lov
  const angle = percentage * 3.6; // In degrees
  const radians = (angle - 90) * (Math.PI / 180); // Convert to radians
  const radius = 35; // Radius of the ring
  const smallCircleOffset = 8; // Offset for small circle
  const [universalSearch, setUniversalSearch] = useState("");
  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const dispatch = useDispatch();
  const debounceTimeoutRef = useRef(null);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  
  const [open, setOpen] = useState(false);
  const practiseid = window.getPracticeId();
  const [initialData, setInitialData] = useState([]);
  const smallCircleStyle = {
    position: "absolute",
    top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px",
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  };

  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  React.useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile]);

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const handletabs = (e) => {
    if (e === 8) return;
    setTab(e);
  };

  const handleChange = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelovValue(numericValue));
  };

  const handletovChange = (newValue) => {
    dispatch(updateTovValue(newValue));
    setSelectedOption(newValue);
  };

  const handleChange2 = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelov2Value(numericValue));
  };

  const handletov2Change = (newValue) => {
    dispatch(updateTov2Value(newValue));
  };
useEffect(()=>{
if(tovValue!==selectedOption){
setSelectedOption(tovValue)
}
},[tovValue])
const updatelov2api=async()=>{
  try {
    setLoading(true)
   const response= await api.delete(
            `/v1/${practiseid}/orders/delete/patient/${data.patientid}/secondtovtask`,{
           data: {
              task: "VISIT",
              orderdate:
        data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
              lov2: 0,
              tov2: '',
            }}
          )
          if(response.status==200){
            
            
              //  updatedashboard()
                  
        //         setToastSeverity("success");
        // setToastMessage(response?.message || "Type of Visit Updated Successfully");
        // setOpenToast(true);
          }else{
        //         setToastSeverity("info");
        // setToastMessage(response?.message || "Something Went Wrong");
        // setOpenToast(true);
          }
  } catch (error) {
    console.log(error)
      // setToastSeverity("error");
      //   setToastMessage("Something Went Wrong");
      //   setOpenToast(true);
  }finally{
setLoading(false)
  }
}
  const fetchData = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/orders/patient/${appointmentInfo?.patientid}/condition`
      );
      if (response.status === 200) {
        setInitialData(response.pConditions);
      }
    } catch (error) {
      console.error("Error fetching patient conditions:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlediagnosis = () => {
    setisDiagnosisPopup(true);
  };

  const navItems = [{ label: "DIAGNOSIS", id: 8, badge: 8, icon: "DX" }];

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);

  const handleMenuClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setMenuIndex(index);
  };

  // Options for Type of Visit, excluding the selected tovValue for tov2
  const tovOptions = [
    "New Patient",
    "Follow up",
    "Consultation",
    "Wellness Commercial",
    "Wellness Medicare",
    "Others",
    "Nurse Visit",
    "Labs",
  ].filter((option) => option !== tovValue);

  return (
    <>
      <div
        className={`fixed z-50 items-center overflow-auto top-18 left-0 h-[100%] bg-[white] rounded-b-lg shadow-[0px_14px_42px_0px_rgba(0,_0,_0,_0.06)] transition-all ${
          miniSidenav ? "w-[10%] sm:w-[4%]" : "w-[38%] sm:w-[18%] "
        }`}
      >
        <div
          className={`flex items-center ${
            miniSidenav ? "justify-center" : "justify-end"
          }`}
        >
          <div onClick={handleCollapse}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g filter="url(#filter0_d_787_7715)">
                <circle
                  cx="24"
                  cy="24"
                  r="16"
                  transform="rotate(-180 24 24)"
                  fill="#E17954"
                />
              </g>
              <foreignObject
                x="16.5"
                y="9"
                width="15"
                height="30"
                style={{ cursor: "pointer" }}
              >
                {miniSidenav ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="30"
                    viewBox="0 0 15 30"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.6962 15.8887L5.62492 22.96L3.85742 21.1925L10.0449 15.005L3.85742 8.81749L5.62492 7.04999L12.6962 14.1212C12.9305 14.3556 13.0622 14.6735 13.0622 15.005C13.0622 15.3364 12.9305 15.6543 12.6962 15.8887Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="30"
                    viewBox="0 0 15 30"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.30383 14.1113L9.37508 7.04001L11.1426 8.80751L4.95508 14.995L11.1426 21.1825L9.37508 22.95L2.30383 15.8788C2.06949 15.6444 1.93785 15.3265 1.93785 14.995C1.93785 14.6636 2.06949 14.3457 2.30383 14.1113Z"
                      fill="white"
                    />
                  </svg>
                )}
              </foreignObject>
              <defs>
                <filter
                  id="filter0_d_787_7715"
                  x="0"
                  y="0"
                  width="48"
                  height="48"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="4" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_787_7715"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_787_7715"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
        <>
          <div className="w-full flex items-center justify-center ">
            <div className="w-[20%] lg:w-auto items-center flex flex-col ">
              <div
                className={`relative flex justify-center items-center ${
                  miniSidenav ? "w-[75px]" : "w-[90px]"
                } h-[90px] mb-0`}
              >
                <div
                  className={`relative flex justify-center items-center rounded-[14px] ${
                    miniSidenav ? "w-[40px] h-[40px]" : "w-[54px] h-[54px] "
                  } mb-0`}
                  style={circleStyle}
                >
                  <div
                    className={`flex justify-center items-center ${
                      miniSidenav ? "w-[45px] h-[45px]" : "w-[67px] h-[67px] "
                    } `}
                  >
                    <img
                      src={`/cloud-assets/chim/public/assets/images/profilepictures/${data?.patientid}.png`}
                      alt="profile"
                      className={`flex justify-center items-center rounded-[11px] ${
                        miniSidenav ? "w-[36px] h-[36px]" : "w-[50px] h-[50px] "
                      } bg-[#C4C4C4] `}
                      onError={(e) =>
                        (e.target.src =
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                      }
                    />
                  </div>
                </div>
              </div>
              {!miniSidenav && (
                <div className="w-full px-2 flex flex-col items-center mb-0">
                  <div className="flex gap-1 items-center align-center">
                    <div className="font-medium text-[#202020] text-[13px] font-inter text-center">
                      {`${data?.firstname || ""} ${
                        data?.lastname || ""
                      }`.trim()}
                    </div>
                    <div className="font-medium text-[#7e7e7e] font-inter text-[12px] text-center">
                      #{data?.patientid}
                    </div>
                  </div>
                  <div className="font-inter text-[#7E7E7E] text-[12px] text-center">
                    {formattedDob(data?.dob)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
        <div className="w-full flex flex-col items-center justify-center">
          <div>
            {miniSidenav ? (
              <div
                className="flex items-center font-inter text-xs text-[#1E2A4A] cursor-pointer"
                onClick={handlediagnosis}
              >
                DX
              </div>
            ) : (
              <div></div>
            )}
          </div>
          {!miniSidenav && (
            <div className="[font-family:'Tahoma'] flex flex-column items-center py-1 text-[#1d2951] text-xs leading-[normal]">
              <div>
                <div className="flex justify-between font-inter items-center sm:w-[190px]">
                  DIAGNOSIS
                  <div>
                    {!miniSidenav ? (
                      <div
                        className="flex items-center cursor-pointer"
                        onClick={handlediagnosis}
                      >
                        <AddIcon />
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="mt-2 max-h-[155px] overflow-y-auto bg-gray-40 rounded-[10px] thin-visible-scrollbar border-[1.5px] border-gray-100 mx-2 "
               
              >
                <ul className="list-disc pl-4 ">
                  {initialData.length > 0 ? (
                    initialData.map((condition) => (
                      <li
                        key={condition.id}
                        className="font-semibold text-left text-[#4B5563] text-xs font-thin mb-2 my-2 cursor-default"
                      >
                        <strong>{condition.condition_name}</strong>
                      </li>
                    ))
                  ) : (
                    <p>No conditions available.</p>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
        <div>
          {miniSidenav && (
            <div className="flex flex-col gap-2 w-full items-center mt-4">
              <img
                onClick={() => setIsCollapsed(!isCollapsed)}
                src={Fallowup}
                className="cursor-pointer"
                style={{ width: "20px" }}
                alt="%$"
              />
              <img
                onClick={() => setIsCollapsed(!isCollapsed)}
                src={Level}
                className="mt-2 cursor-pointer"
                style={{ width: "20px" }}
                alt="%$"
              />
            </div>
          )}
          {!miniSidenav && (
            <div className="text-[#1d2951] text-xs leading-[normal] ml-2 relative">
              <div className="text-[#1E2A4A] text-[13px] font-semibold font-Font1 leading-[normal] ml-2 mt-2 text-left">
                TYPE OF VISIT
              </div>
              <div className="flex justify-between font-inter items-center sm:w-[190px]">
                <select
                  value={selectedOption}
                  onChange={(e) => handletovChange(e.target.value)}
                  className="mt-2 block w-[90%] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1d2951] text-[#1d2951] text-xs leading-[normal] ml-2"
                >
                  <option value="" disabled>
                    Select a Visit
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="New Patient"
                  >
                    New Patient
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Follow up"
                  >
                    Follow up
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Consultation"
                  >
                    Consultation
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Wellness Commercial"
                  >
                    Wellness Commercial
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Wellness Medicare"
                  >
                    Wellness Medicare
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Others"
                  >
                    Others
                  </option>
                  <option
                    className="font-semibold cursor-pointer"
                    value="Nurse Visit"
                  >
                    Nurse Visit
                  </option>
                  <option className="font-semibold cursor-pointer" value="Labs">
                    Labs
                  </option>
                </select>
               
              </div>
              {tovValue?.includes("New Patient") ||
              tovValue?.includes("Follow up") ||
              tovValue?.includes("Consultation") ? (
                <div className="w-full flex flex-column text-left justify-center items-center mt-2">
                  <div className="text-[12px] font-semibold font-Font1 tracking-tight text-left w-full pl-3">
                    LEVEL OF VISIT
                  </div>
                  <div className="flex justify-center w-full mt-2">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <button
                        key={value}
                        onClick={() => handleChange(value)}
                        className={`px-[10px] py-[5px] mx-1 text-xs shadow-md font-bold border-[1px] border-[#ccc] rounded-lg ${
                          lovValue === value
                            ? "bg-[#E17954] text-white"
                            : "bg-[white] text-black"
                        } focus:outline-none`}
                        style={{ transition: "background-color 0.3s ease" }}
                      >
                        {value}
                      </button>
                    ))}
                     <div
                  className="flex items-center cursor-pointer"
                  onClick={handleOpenExtra}
                >
                  <AddIcon />
                </div>
                  </div>
                </div>
              ) : tovValue?.includes("Wellness Commercial") ||
                tovValue?.includes("Wellness Medicare") ? (
                <div className="w-full flex flex-column space-x-4">
                  <div className="font-poppins mt-2 ml-4 font-[13px] tracking-tight text-left items-left">
                    Level of Visit
                  </div>
                  <select
                    value={lovValue}
                    onChange={(e) => handleChange(e.target.value)}
                    className="w-48 h-8 px-2 text-xs font-poppins font-thin tracking-tight border rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="1">First</option>
                    <option value="2">Subsequent</option>
                  </select>
                </div>
              ) : null}
              {/* {showExtraTovLov && (
                <div className="absolute right-0 top-0 bg-green-200">
                  <div className="text-[#1E2A4A] text-[13px] font-semibold font-Font1 leading-[normal] ml-2 mt-4 text-left">
                    TYPE OF VISIT
                  </div>
                  <select
                    value={tov2Value}
                    onChange={(e) => handletov2Change(e.target.value)}
                    className="mt-2 block w-[90%] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1d2951] text-[#1d2951] text-xs leading-[normal] ml-2"
                  >
                    {tovOptions
                      .filter(
                        (option) =>
                          option === "Wellness Commercial" ||
                          option === "Wellness Medicare"
                      )
                      .map((option) => (
                        <option
                          key={option}
                          className="font-semibold cursor-pointer"
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                  </select>

                  <div className="w-full flex flex-column space-x-4">
                    <div className="font-poppins mt-2 ml-4 font-[13px] tracking-tight text-left items-left">
                      Level of Visit{" "}
                    </div>
                    <select
                      value={lov2Value}
                      onChange={(e) => handleChange2(e.target.value)}
                      className="w-48 h-8 px-2 text-xs font-poppins font-thin tracking-tight border rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="1">First</option>
                      <option value="2">Subsequent</option>
                    </select>
                  </div>
                </div>
              )} */}

              <Popover
                open={extraOpen}
                anchorEl={extraAnchorEl}
                onClose={handleCloseExtra}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{
                  sx: {
                    p: 2,
                    width: 260,
                    borderRadius: 2,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
                    position: "relative",
                    overflow: "visible", // <- allow dropdown to spill out
                    "&::before": {
                      /* ...arrow... */
                    },
                  },
                }}
              >
                <div className="text-[13px] font-medium text-[#7E7E7E] mb-2">
                  Type Of Visit
                </div>
                {/* <select
                  value={tov2Value}
                  onChange={(e) => handletov2Change(e.target.value)}
                  className="block w-full px-3 py-2 mb-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1d2951] text-[#1d2951] text-xs"
                >
                  {tovOptions
                    .filter(
                      (option) =>
                        option === "Wellness Commercial" ||
                        option === "Wellness Medicare"
                    )
                    .map((option) => (
                      <option
                        key={option}
                        value={option}
                        className="font-semibold"
                      >
                        {option}
                      </option>
                    ))}
                </select> */}
                <CustomDropdown
                  options={tovOptions
                    .filter(
                      (o) =>
                        o === "Wellness Commercial" || o === "Wellness Medicare"
                    )
                    .map((o) => ({ value: o, label: o }))}
                  value={tov2Value}
                  onChange={handletov2Change}
                  placeholder="Select Type"
                />

                <div className="text-[12px] font-semibold text-[#1E2A4A] mb-1">
                  Level of Visit
                </div>
                <CustomDropdown
                  options={[
                    { value: "1", label: "First" },
                    { value: "2", label: "Subsequent" },
                  ]}
                  value={lov2Value}
                  onChange={handleChange2}
                />
              </Popover>
            </div>
          )}
        </div>
              {tov2Value && (
                  <div className="flex items-center w-fit px-3 mx-3 py-1 mt-2 rounded-full border-[1px] border-[#E17954] bg-[#E179542E]">
                    <span className="text-xs font-medium font-inter text-[#7E7E7E]">
                      {tov2Value}
                    </span>
                    <span className="ml-2 flex items-center justify-center w-5 h-5 rounded-full bg-[#E17954] text-white text-xs font-bold shadow-sm">
                      {lov2Value || "-"}
                    </span>
                    <CloseIcon
                      className="ml-2 cursor-pointer text-[#E17954]" 
                      style={{ fontSize: "16px" }}
                      onClick={() => {
                        dispatch(updateTov2Value(null));
                        dispatch(updatelov2Value(null));
updatelov2api()
                      }}
                    />
                  </div>
                )}
      </div>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
        <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
              }}
              open={isLoading}
            >
              <CircularProgress
               color="inherit" />
            </Backdrop>
      <DiagnosisPopup
        appid={appointmentInfo}
        setAlertMessage={setAlertMessage}
        setSeverity={setSeverity}
        setOpen={setOpen}
        isOpen={diagnosispopup}
        onClose={() => setisDiagnosisPopup(false)}
      />
    </>
  );
};

export default OrdersSideNav;
